<template>
    <div class="container">
        <vue-headful title="ABL Groupe | FALCI" />
        <h2>FALCI</h2>
        <section class="society--process">
            <div class="society--content">
                <div class="society--process--picture col-xs-12 col-md-5">
                    <img :src="require('../../../assets/images/Laminechaud_Falci.jpg')"/></div>
                <div class="society--process--description flex-end col-xs-12 col-md-5">
                    <div class="col-xs-12">
                        <h3>Profilés spéciaux de précision en acier laminés à chaud </h3>
                        <div>Ces produits réalisés sur plan client peuvent être livrés en barres ou en bobines dans la
                            gamme suivante :
                        </div>
                        <div>
                            <p>Section maximum : 640 mm²</p>
                        </div>
                        <div>
                            <p>Largeur maximum : 70 mm (épaisseur mini. 3mm) selon section</p>
                        </div>
                        <div>
                            <p>Poids / mètre : 0,30 à 6 kg</p>
                        </div>
                        <h3>Precision hot rolled steel special profiles </h3>
                        <div>Products manufactured according to customer drawing can be to supplied as bars or coils in
                            the following range :
                        </div>
                        <div>
                            <p>Maximum section : 640 mm²</p>
                        </div>
                        <div>
                            <p>Maximum width : 55 mm (minimum thickness 2mm) depending on section</p>
                        </div>
                        <div>
                            <p>Weight / meter : 0,30 up to 6 kg</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    export default {
        name: "FalciHotrolled"
    }
</script>

<style scoped>

</style>